// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-data-wipmusic-js": require("gatsby-module-loader?name=component---src-pages-data-wipmusic-js!/opt/build/repo/src/pages/data/wipmusic.js"),
  "component---src-pages-endless-js": require("gatsby-module-loader?name=component---src-pages-endless-js!/opt/build/repo/src/pages/endless.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-live-js": require("gatsby-module-loader?name=component---src-pages-live-js!/opt/build/repo/src/pages/live.js"),
  "component---src-pages-turntable-js": require("gatsby-module-loader?name=component---src-pages-turntable-js!/opt/build/repo/src/pages/turntable.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "data-wipmusic.json": require("gatsby-module-loader?name=path---data-wipmusic!/opt/build/repo/.cache/json/data-wipmusic.json"),
  "endless.json": require("gatsby-module-loader?name=path---endless!/opt/build/repo/.cache/json/endless.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "live.json": require("gatsby-module-loader?name=path---live!/opt/build/repo/.cache/json/live.json"),
  "turntable.json": require("gatsby-module-loader?name=path---turntable!/opt/build/repo/.cache/json/turntable.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js